export default __webpack_public_path__ + "static/media/logomadlex.4ac96917.png";